import { WorkflowSchema, WorkflowStatus } from "@validereinc/domain";
import { z } from "zod";

export const WorkflowsTableFilterSchema = z
  .object({
    date_range: z.object({
      from: z.string().datetime(),
      to: z.string().datetime().optional(),
    }),
    facilityId: z.array(z.string()),
    equipmentId: z.array(z.string()),
    deviceId: z.array(z.string()),
    flowId: z.array(z.string()),
    assetGroupId: z.array(z.string()),
    workflow: z.record(z.any()),
    status: z.array(
      z.union([
        z.literal(""),
        z.enum([
          WorkflowStatus.COMPLETE,
          WorkflowStatus.DISMISSED,
          WorkflowStatus.IN_PROGRESS,
          WorkflowStatus.MISSED,
          WorkflowStatus.OVERDUE,
        ]),
      ])
    ),
  })
  .merge(
    WorkflowSchema.pick({
      name: true,
    })
  )
  .partial();
export const WorkflowsTableFilterSchemaKeys =
  WorkflowsTableFilterSchema.keyof().Enum;

export type WorkflowsTableFiltersType = z.infer<
  typeof WorkflowsTableFilterSchema
>;
